

// const IP = 'http://192.168.2.30:8081/ptowp'		// 本地的IP


const IP = 'https://www.bddiscern.com:8081/ptowp'		//	线上的IP
  
export default {
	IP
}



// WEBPACK FOOTER //
// ./src/global/index.js